module.exports = __webpack_public_path__ + "static/media/icn-back.b296f3ee.svg";